import React from "react";
import { hydrateRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "../store";
import NotFoundPage from "../pages/NotFound";

// Auto-generated route map (run `npm run routes` to regenerate)
import { routes, App, routeChunkMap } from "./generated-routes";
import { RouterProvider } from "../shared/RouterContext";

// Expose chunk map globally for the prefetch system
// (prefetchCache.ts reads this to know which JS chunk to preload on hover)
(window as any).__BLUMEN_CHUNK_MAP__ = routeChunkMap;

function init() {
	const container = document.getElementById("root");
	if (!container) {
		console.error("Root element not found");
		return;
	}

	// Get props from server (used for the initial SSR hydration)
	const propsElement = document.getElementById("ssr-props");
	const propsText = propsElement?.textContent?.trim();
	const initialProps = propsText ? JSON.parse(propsText) : {};

	// Hydrate the app with Redux Provider and RouterProvider.
	// Error boundaries are handled inside RouterProvider to ensure
	// the DOM tree matches what the SSR server produces.
	hydrateRoot(
		container,
		<Provider store={store}>
			<RouterProvider
				routes={routes}
				App={App}
				notFoundComponent={NotFoundPage}
				initialProps={initialProps}
			/>
		</Provider>,
	);

	console.log("Hydrated with client-side router:", window.location.pathname);
}

// Initialize when DOM is ready
if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", init);
} else {
	init();
}

